export default "__VITE_ASSET__webZTxRD__";